exports.categories = [
  {
    key: 'PERIPHERAL',
    label: {
      en: 'Peripheral',
      es: 'Peripheral',
    },
  },
  {
    key: 'INTRAOSSEOUS',
    label: {
      en: 'Intraosseous',
      es: 'Intraosseous',
    },
  },
];

exports.oasCategories = [
  {
    key: 'CENTRAL_LINE',
    label: {
      en: 'Central Line',
      es: 'Central Line',
    },
    productTypes: [
      'NURSING',
    ]
  },
  {
    key: 'PICC',
    label: {
      en: 'PICC',
      es: 'PICC',
    },
    productTypes: [
      'EMS',
      'NURSING',
    ]
  },
  {
    key: 'PORTACATH',
    label: {
      en: 'PortaCath',
      es: 'PortaCath',
    },
    productTypes: [
      'EMS',
      'NURSING',
    ]
  },
  {
    key: 'INTRODUCER',
    label: {
      en: 'Introducer',
      es: 'Introducer',
    },
    productTypes: [
      'NURSING',
    ]
  },
  {
    key: 'SHEATH',
    label: {
      en: 'Sheath',
      es: 'Sheath',
    },
    productTypes: [
      'NURSING',
    ]
  },
  {
    key: 'DIALYSIS_CATHETER',
    label: {
      en: 'Dialysis Catheter',
      es: 'Dialysis Catheter',
    },
    productTypes: [
      'EMS',
      'NURSING',
    ]
  },
];

exports.sides = [
  {
    key: 'LEFT',
    label: {
      en: 'Left',
      es: 'Left',
    },
  },
  {
    key: 'RIGHT',
    label: {
      en: 'Right',
      es: 'Right',
    },
  },
  {
    key: 'BOTH',
    label: {
      en: 'Center',
      es: 'Center',
    },
  },
];

exports.sites = [
  {
    label: {
      en: 'Scalp',
      es: 'Scalp',
    },
    key: 'IV_SCALP',
    category: 'PERIPHERAL',
    centerOnly: true,
  },
  {
    label: {
      en: 'EJ',
      es: 'EJ',
    },
    key: 'IV_EJ',
    category: 'PERIPHERAL',
  },
  {
    label: {
      en: 'Antecubital Vein',
      es: 'Antecubital Vein',
    },
    key: 'IV_ANTECUBITAL',
    category: 'PERIPHERAL',
  },
  {
    label: {
      en: 'Forearm',
      es: 'Forearm',
    },
    key: 'IV_FOREARM',
    category: 'PERIPHERAL',
  },
  {
    label: {
      en: 'Hand',
      es: 'Hand',
    },
    key: 'IV_HAND',
    category: 'PERIPHERAL',
  },
  {
    label: {
      en: 'Foot',
      es: 'Foot',
    },
    key: 'IV_FOOT',
    category: 'PERIPHERAL',
  },
  {
    label: {
      en: 'Sternum',
      es: 'Sternum',
    },
    key: 'IO_STERNUM',
    category: 'INTRAOSSEOUS',
    centerOnly: true,
  },
  {
    label: {
      en: 'Humerus',
      es: 'Humerus',
    },
    key: 'IO_HUMERUS',
    category: 'INTRAOSSEOUS',
  },
  {
    label: {
      en: 'Iliac Crest',
      es: 'Iliac Crest',
    },
    key: 'IO_ILIAC_CREST',
    category: 'INTRAOSSEOUS',
  },
  {
    label: {
      en: 'Distal Femur',
    },
    key: 'IO_DISTAL_FEMUR',
    category: 'INTRAOSSEOUS',
  },
  {
    label: {
      en: 'Proximal Tibia',
      es: 'Proximal Tibia',
    },
    key: 'IO_PROXIMAL_TIBIA',
    category: 'INTRAOSSEOUS',
  },
  {
    label: {
      en: 'Distal Tibia',
      es: 'Distal Tibia',
    },
    key: 'IO_DISTAL_TIBIA',
    category: 'INTRAOSSEOUS',
  },
  {
    label: {
      en: 'Internal Jugular',
      es: 'Internal Jugular',
    },
    key: 'INTERNAL_JUGULAR',
    category: 'CENTRAL_LINE',
  },
  {
    label: {
      en: 'Subclavian',
      es: 'Subclavian',
    },
    key: 'SUBCLAVIAN',
    category: 'CENTRAL_LINE',
  },
  {
    label: {
      en: 'Femoral',
      es: 'Femoral',
    },
    key: 'FEMORAL',
    category: 'CENTRAL_LINE',
  },
  {
    label: {
      en: 'Upper Arm',
      es: 'Upper Arm',
    },
    key: 'UPPER_ARM',
    category: 'PICC',
  },
  {
    label: {
      en: 'Chest Wall',
      es: 'Chest Wall',
    },
    key: 'CHEST_WALL',
    category: 'PORTACATH',
  },
];

exports.needleGauges = [
  {
    label: {
      en: '14G',
      es: '14G',
    },
    key: 'GAUGE_14',
    category: 'PERIPHERAL'
  },
  {
    label: {
      en: '16G',
      es: '16G',
    },
    key: 'GAUGE_16',
    category: 'PERIPHERAL'
  },
  {
    label: {
      en: '18G',
      es: '18G',
    },
    key: 'GAUGE_18',
    category: 'PERIPHERAL'
  },
  {
    label: {
      en: '20G',
      es: '20G',
    },
    key: 'GAUGE_20',
    category: 'PERIPHERAL'
  },
  {
    label: {
      en: '22G',
      es: '22G',
    },
    key: 'GAUGE_22',
    category: 'PERIPHERAL'
  },
  {
    label: {
      en: '24G',
      es: '24G',
    },
    key: 'GAUGE_24',
    category: 'PERIPHERAL'
  },
  {
    label: {
      en: '5FR',
      es: '5FR',
    },
    key: 'GAUGE_FR_5',
    category: 'PICC'
  },
  {
    label: {
      en: '6FR',
      es: '6FR',
    },
    key: 'GAUGE_FR_6',
    category: 'PORTACATH'
  },
  {
    label: {
      en: '7FR',
      es: '7FR',
    },
    key: 'GAUGE_FR_7',
    category: 'CENTRAL_LINE'
  },
  {
    label: {
      en: '9FR',
      es: '9FR',
    },
    key: 'GAUGE_FR_9',
    category: 'INTRODUCER'
  },
  {
    label: {
      en: '10FR',
      es: '10FR',
    },
    key: 'GAUGE_FR_10',
    category: 'SHEATH'
  },
  {
    label: {
      en: '12FR',
      es: '12FR',
    },
    key: 'GAUGE_FR_12',
    category: 'DIALYSIS_CATHETER'
  },
];

exports.needleSets = [
  {
    label: {
      en: '15mm',
      es: '15mm',
    },
    key: 'NEEDLE_SET_15',
  },
  {
    label: {
      en: '25mm',
      es: '25mm',
    },
    key: 'NEEDLE_SET_25',
  },
  {
    label: {
      en: '38.5mm',
      es: '38.5mm',
    },
    key: 'NEEDLE_SET_38_5',
  },
  {
    label: {
      en: '45mm',
      es: '45mm',
    },
    key: 'NEEDLE_SET_45',
  },
];

exports.portAmounts = [
  {
    key: 'ONE_PORT',
    label: {
      en: 'One Port',
      es: 'One Port',
    },
    defaultPorts: [
      'PORT_1'
    ],
    categoryPorts: {
      'CENTRAL_LINE': [
        'PROXIMAL'
      ],
      'PICC': [
        'PROXIMAL'
      ],
    },
    portCount: 1
  },
  {
    key: 'TWO_PORTS',
    label: {
      en: 'Two Ports',
      es: 'Two Ports',
    },
    defaultPorts: [
      'PORT_1', 'PORT_2'
    ],
    categoryPorts: {
      'CENTRAL_LINE': [
        'PROXIMAL', 'DISTAL'
      ],
      'PICC': [
        'PROXIMAL', 'MEDIAL_1'
      ]
    },
    portCount: 2
  },
  {
    key: 'THREE_PORTS',
    label: {
      en: 'Three Ports',
      es: 'Three Ports',
    },
    categoryPorts: {
      'CENTRAL_LINE': [
        'PROXIMAL', 'DISTAL', 'MEDIAL_1'
      ],
      'PICC': [
        'PROXIMAL', 'MEDIAL_1', 'DISTAL'
      ]
    },
    portCount: 3
  },
  {
    key: 'FOUR_PORTS',
    label: {
      en: 'Four Ports',
      es: 'Four Ports',
    },
    categoryPorts: {
      'CENTRAL_LINE': [
        'PROXIMAL', 'DISTAL', 'MEDIAL_1', 'MEDIAL_2'
      ]
    },
    portCount: 4
  },
  {
    key: 'ARTERIAL_VENOS',
    label: {
      en: 'Arterial/Venous',
      es: 'Arterial/Venous',
    },
    defaultPorts: [
      'ARTERIAL', 'VENOUS'
    ],
    portCount: 2
  },
];

exports.portNames = [
  {
    key: 'PORT_1',
    label: {
      en: 'Port 1',
    },
  },
  {
    key: 'PORT_2',
    label: {
      en: 'Port 2',
    },
  },
  {
    key: 'PROXIMAL',
    label: {
      en: 'Proximal',
    },
  },
  {
    key: 'MEDIAL_1',
    label: {
      en: 'Medial 1',
    },
    categoryLabel: {
      'PICC': {
        en: 'Medial'
      }
    }
  },
  {
    key: 'MEDIAL_2',
    label: {
      en: 'Medial 2',
    },
  },
  {
    key: 'DISTAL',
    label: {
      en: 'Distal',
    },
  },
  {
    key: 'ARTERIAL',
    label: {
      en: 'Arterial',
    },
  },
  {
    key: 'VENOUS',
    label: {
      en: 'Venous',
    },
  },
];

exports.tubings = [
  {
    label: {
      en: '10 GTT',
      es: '10 GTT',
    },
    key: 'GTT_10',
    gttPerMl: 10
  },
  {
    label: {
      en: '15 GTT',
      es: '15 GTT',
    },
    key: 'GTT_15',
    gttPerMl: 15
  },
  {
    label: {
      en: '60 GTT',
      es: '60 GTT',
    },
    key: 'GTT_60',
    gttPerMl: 60
  },
];

exports.oasPlacements = [
  {
    type: 'CENTRAL_LINE',
    ports: [
      'ONE_PORT',
      'TWO_PORTS',
      'THREE_PORTS',
      'FOUR_PORTS',
    ],
    portNames: [
      'PROXIMAL', 'DISTAL', 'MEDIAL_1', 'MEDIAL_2'
    ],
    sites: [
      {
        site: 'INTERNAL_JUGULAR',
        sides: [
          'LEFT',
          'RIGHT'
        ]
      },
      {
        site: 'SUBCLAVIAN',
        sides: [
          'LEFT',
          'RIGHT'
        ]
      },
      {
        site: 'FEMORAL',
        sides: [
          'LEFT',
          'RIGHT'
        ]
      },
    ],
    gauges: [
      'GAUGE_FR_7'
    ],
    productTypes: [
      'NURSING',
    ]
  },
  {
    type: 'PICC',
    ports: [
      'ONE_PORT',
      'TWO_PORTS',
      'THREE_PORTS'
    ],
    portNames: [
      'PROXIMAL', 'MEDIAL_1', 'DISTAL'
    ],
    sites: [
      {
        site: 'UPPER_ARM',
        sides: [
          'LEFT',
          'RIGHT'
        ]
      },
    ],
    gauges: [
      'GAUGE_FR_5'
    ],
    productTypes: [
      'EMS',
      'NURSING',
    ]
  },
  {
    type: 'PORTACATH',
    ports: [
      'ONE_PORT',
    ],
    portNames: [
      'PORT_1'
    ],
    sites: [
      {
        site: 'CHEST_WALL',
        sides: [
          'LEFT',
          'RIGHT'
        ]
      },
    ],
    gauges: [
      'GAUGE_FR_6'
    ],
    productTypes: [
      'EMS',
      'NURSING',
    ]
  },
  {
    type: 'INTRODUCER',
    ports: [
      'ONE_PORT',
      'TWO_PORTS',
    ],
    portNames: [
      'PORT_1', 'PORT_2'
    ],
    sites: [
      {
        site: 'INTERNAL_JUGULAR',
        sides: [
          'LEFT',
          'RIGHT'
        ]
      },
      {
        site: 'SUBCLAVIAN',
        sides: [
          'LEFT',
          'RIGHT'
        ]
      },
      {
        site: 'FEMORAL',
        sides: [
          'LEFT',
          'RIGHT'
        ]
      },
    ],
    gauges: [
      'GAUGE_FR_9'
    ],
    productTypes: [
      'NURSING',
    ]
  },
  {
    type: 'SHEATH',
    ports: [
      'TWO_PORTS',
    ],
    portNames: [
      'PORT_1', 'PORT_2'
    ],
    sites: [
      {
        site: 'INTERNAL_JUGULAR',
        sides: [
          'LEFT',
          'RIGHT'
        ]
      },
      {
        site: 'FEMORAL',
        sides: [
          'LEFT',
          'RIGHT'
        ]
      },
    ],
    gauges: [
      'GAUGE_FR_10'
    ],
    productTypes: [
      'NURSING',
    ]
  },
  {
    type: 'DIALYSIS_CATHETER',
    ports: [
      'ARTERIAL_VENOS',
    ],
    portNames: [
      'ARTERIAL', 'VENOUS'
    ],
    sites: [
      {
        site: 'INTERNAL_JUGULAR',
        sides: [
          'LEFT',
          'RIGHT'
        ]
      },
      {
        site: 'SUBCLAVIAN',
        sides: [
          'LEFT',
          'RIGHT'
        ]
      },
    ],
    gauges: [
      'GAUGE_FR_12'
    ],
    productTypes: [
      'EMS',
      'NURSING',
    ]
  },
];

